import { RootStateModel } from '../models/root-state.model';

export const loadingPendingMatcher = (state: RootStateModel) => {
  state.isLoading = true;
};
